import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";

function hasToken(): boolean {
  try {
    const t = localStorage.getItem("auth_token");
    return !!t && t.trim() !== "";
  } catch {
    return false;
  }
}

/**
 * Protegge le route figlie. Se non autenticato, redirect a /login mantenendo il ritorno.
 * In futuro potremo supportare aree pubbliche montandole fuori da questo wrapper.
 */
export default function RequireAuth() {
  const location = useLocation();
  const authed = hasToken();
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}


